(function () {
  const cfg = window.HorizonFxConfig || {};
  const apiUrl = cfg.apiUrl;
  const geoApiUrl = cfg.geoApiUrl;
  const storageKey = cfg.storageKey || "horizon_currency_mode";
  const selectors = Array.isArray(cfg.selectors) && cfg.selectors.length
    ? cfg.selectors
    : ["[data-fx-price]"];
  const storeCurrency = String(cfg.baseCurrency || "TRY").toUpperCase();

  const fxState = {
    rates: { EUR: 1, USD: 1, TRY: 1 },
    baseCurrency: storeCurrency,
    source: "init",
    updatedAt: null
  };

  const geoState = {
    country: null,
    continentCode: null,
    currency: storeCurrency,
    source: "fallback",
    fallback: true,
    cached: false,
    updatedAt: null
  };

  let observerStarted = false;
  let burstTimer = null;
  let burstPass = 0;

  function normalizeCurrency(code) {
    return String(code || storeCurrency).toUpperCase();
  }

  function readMode() {
    try {
      return localStorage.getItem(storageKey) || cfg.defaultMode || "auto";
    } catch (err) {
      return cfg.defaultMode || "auto";
    }
  }

  function writeMode(mode) {
    try {
      localStorage.setItem(storageKey, mode);
    } catch (err) {}
  }

  function browserLocaleCurrency() {
    const locale = (navigator.language || "en-US").toLowerCase();
    const region = locale.includes("-")
      ? locale.split("-").pop().toUpperCase()
      : locale.slice(-2).toUpperCase();

    const map = {
      AT: "EUR",
      BE: "EUR",
      DE: "EUR",
      ES: "EUR",
      FI: "EUR",
      FR: "EUR",
      GR: "EUR",
      IE: "EUR",
      IT: "EUR",
      NL: "EUR",
      PT: "EUR",
      TR: "TRY",
      GB: "USD",
      US: "USD"
    };

    return map[region] || storeCurrency;
  }

  function geoCurrency() {
    const currency = normalizeCurrency(geoState.currency || storeCurrency);
    if (geoState.fallback) return null;
    return currency;
  }

  function resolvedCurrency() {
    const mode = readMode();
    if (mode !== "auto") return normalizeCurrency(mode);
    return geoCurrency() || browserLocaleCurrency() || storeCurrency;
  }

  function rateFor(code) {
    const value = Number((fxState.rates || {})[normalizeCurrency(code)]);
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  function parseMoney(text) {
    const cleaned = String(text || "")
      .replace(/[^\d.,-]/g, "")
      .replace(/\s/g, "");

    if (!cleaned) return null;

    const normalized =
      cleaned.includes(",") && cleaned.includes(".")
        ? cleaned.lastIndexOf(",") > cleaned.lastIndexOf(".")
          ? cleaned.replace(/\./g, "").replace(",", ".")
          : cleaned.replace(/,/g, "")
        : cleaned.replace(",", ".");

    const num = Number(normalized);
    return Number.isFinite(num) ? num : null;
  }

  function formatMoney(amount, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || "en", {
      style: "currency",
      currency,
      maximumFractionDigits: 2
    }).format(amount);
  }

  // Prices in the theme are stored in storeCurrency (TRY).
  // Rates from the backend are relative to fxState.baseCurrency (often EUR).
  // So we convert TRY -> rate-base -> target:
  // amountInRateBase = amount / rate(storeCurrency)
  // converted = amountInRateBase * rate(target)
  function convertFromBase(amount) {
    const targetCurrency = resolvedCurrency();
    const sourceRate = rateFor(storeCurrency);
    const targetRate = rateFor(targetCurrency);

    const amountInRateBase = amount / (sourceRate || 1);
    const converted = amountInRateBase * targetRate;

    return formatMoney(converted, targetCurrency);
  }

  function getBaseAmount(node) {
    if (!node) return null;

    if (node.dataset && node.dataset.fxBaseAmount) {
      const cached = Number(node.dataset.fxBaseAmount);
      if (Number.isFinite(cached)) return cached;
    }

    const originalText =
      (node.dataset && node.dataset.fxOriginal) ||
      node.textContent ||
      "";

    const amount = parseMoney(originalText);
    if (amount === null) return null;

    if (node.dataset) {
      node.dataset.fxBaseAmount = String(amount);
      if (!node.dataset.fxOriginal) node.dataset.fxOriginal = originalText;
    }

    return amount;
  }

  function updatePriceNode(node) {
    const amount = getBaseAmount(node);
    if (amount === null) return;
    node.textContent = convertFromBase(amount);
  }

  function updateAllPrices(root) {
    const scope = root && root.querySelectorAll ? root : document;

    selectors.forEach((selector) => {
      scope.querySelectorAll(selector).forEach((node) => {
        if (!node || node.dataset?.fxSkip) return;
        updatePriceNode(node);
      });
    });
  }

  function currencySymbol(code) {
  const map = {
    TRY: "₺",
    EUR: "€",
    USD: "$"
  };

  return map[normalizeCurrency(code)] || normalizeCurrency(code);
}

function currencySymbol(code) {
  const map = {
    TRY: "₺",
    EUR: "€",
    USD: "$"
  };

  return map[normalizeCurrency(code)] || normalizeCurrency(code);
}

function currencySymbol(code) {
  const map = {
    TRY: "₺",
    EUR: "€",
    USD: "$"
  };

  return map[normalizeCurrency(code)] || normalizeCurrency(code);
}

function updateSwitcherUI() {
  const symbol = currencySymbol(resolvedCurrency());

  document.querySelectorAll("[data-fx-current-currency-label]").forEach((node) => {
    node.textContent = symbol;
  });
}

function currencySymbol(code) {
  const map = {
    TRY: "₺",
    EUR: "€",
    USD: "$"
  };

  return map[normalizeCurrency(code)] || normalizeCurrency(code);
}

function closeCurrencyMenu() {
  document.querySelectorAll("[data-fx-switcher]").forEach((root) => {
    root.classList.remove("is-open");
    const trigger = root.querySelector("[data-fx-trigger]");
    const menu = root.querySelector("[data-fx-menu]");
    if (trigger) trigger.setAttribute("aria-expanded", "false");
    if (menu) menu.hidden = true;
  });
}

function openCurrencyMenu(root) {
  if (!root) return;
  root.classList.add("is-open");
  const trigger = root.querySelector("[data-fx-trigger]");
  const menu = root.querySelector("[data-fx-menu]");
  if (trigger) trigger.setAttribute("aria-expanded", "true");
  if (menu) menu.hidden = false;
}

function toggleCurrencyMenu(root) {
  if (!root) return;
  const isOpen = root.classList.contains("is-open");
  if (isOpen) closeCurrencyMenu();
  else openCurrencyMenu(root);
}

  function burstRefresh() {
    if (burstTimer) return;

    burstPass = 0;

    const run = () => {
      updateAllPrices(document);
      updateSwitcherUI();

      burstPass += 1;

      if (burstPass < 4) {
        burstTimer = window.setTimeout(run, burstPass === 1 ? 80 : 180);
      } else {
        burstTimer = null;
      }
    };

    run();
  }

  async function loadRates() {
    if (!apiUrl) return;

    try {
      const res = await fetch(apiUrl, { credentials: "omit" });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "FX fetch failed");

      fxState.rates = data.rates || fxState.rates;
      fxState.baseCurrency = normalizeCurrency(data.base_currency || fxState.baseCurrency || storeCurrency);
      fxState.source = data.source || "google";
      fxState.updatedAt = data.updated_at || null;
    } catch (err) {
      console.warn("[HorizonFx] FX fetch failed:", err);
    }
  }

  async function loadGeoTarget() {
    if (!geoApiUrl) return;

    const browserLocale = navigator.language || "";
    const browserAcceptLanguage = Array.isArray(navigator.languages)
      ? navigator.languages.join(",")
      : browserLocale;
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";

    const url = new URL(geoApiUrl, window.location.origin);
    if (browserLocale) url.searchParams.set("browser_locale", browserLocale);
    if (browserTimezone) url.searchParams.set("browser_timezone", browserTimezone);
    if (browserAcceptLanguage) url.searchParams.set("browser_accept_language", browserAcceptLanguage);

    try {
      const res = await fetch(url.toString(), { credentials: "omit" });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Geo fetch failed");

      geoState.country = data.country || null;
      geoState.continentCode = data.continent_code || null;
      geoState.currency = normalizeCurrency(data.currency || storeCurrency);
      geoState.source = data.source || "geo";
      geoState.fallback = Boolean(data.fallback);
      geoState.cached = Boolean(data.cached);
      geoState.updatedAt = data.updated_at || null;
    } catch (err) {
      console.warn("[HorizonFx] Geo fetch failed:", err);
      geoState.country = null;
      geoState.continentCode = null;
      geoState.currency = storeCurrency;
      geoState.source = "fallback";
      geoState.fallback = true;
      geoState.cached = false;
      geoState.updatedAt = null;
    }
  }

  function matchesAnySelector(node) {
    return selectors.some((selector) => {
      try {
        return node.matches && node.matches(selector);
      } catch (err) {
        return false;
      }
    });
  }

  function subtreeContainsPrice(node) {
    return selectors.some((selector) => {
      try {
        return node.querySelector && node.querySelector(selector);
      } catch (err) {
        return false;
      }
    });
  }

  function startObserver() {
    if (observerStarted) return;

    const target = document.body || document.documentElement;
    if (!target) return;

    const observer = new MutationObserver((mutations) => {
      let shouldRefresh = false;

      for (const mutation of mutations) {
        if (mutation.type === "characterData") {
          shouldRefresh = true;
          break;
        }

        if (mutation.addedNodes && mutation.addedNodes.length) {
          for (const added of mutation.addedNodes) {
            if (!added || added.nodeType !== 1) continue;

            if (matchesAnySelector(added) || subtreeContainsPrice(added)) {
              shouldRefresh = true;
              break;
            }
          }
        }

        if (shouldRefresh) break;
      }

      if (shouldRefresh) {
        burstRefresh();
      }
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
      characterData: true
    });

    observerStarted = true;
  }

  document.addEventListener("change", function (event) {
    const target = event.target;
    if (target && target.matches("[data-fx-select]")) {
      writeMode(target.value);
      burstRefresh();
    }
  });

  document.addEventListener("click", function (event) {
  const trigger = event.target.closest("[data-fx-trigger]");
  if (trigger) {
    const root = trigger.closest("[data-fx-switcher]");
    toggleCurrencyMenu(root);
    return;
  }

  const option = event.target.closest("[data-fx-currency-value]");
  if (option) {
    const root = option.closest("[data-fx-switcher]");
    const mode = option.getAttribute("data-fx-currency-value") || "auto";
    writeMode(mode);
    closeCurrencyMenu();
    updateSwitcherUI();
    burstRefresh();
    return;
  }

  const clickedInside = event.target.closest("[data-fx-switcher]");
  if (!clickedInside) {
    closeCurrencyMenu();
  }
});

document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") closeCurrencyMenu();
});

  async function init() {
    updateSwitcherUI();
    await loadGeoTarget();
    await loadRates();
    burstRefresh();
    startObserver();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  window.addEventListener("pageshow", () => burstRefresh());
  document.addEventListener("shopify:section:load", () => burstRefresh());
  document.addEventListener("shopify:section:select", () => burstRefresh());

  window.HorizonFx = {
    refresh: async function () {
      await loadGeoTarget();
      await loadRates();
      burstRefresh();
    },
    setMode: function (mode) {
      writeMode(mode);
      updateSwitcherUI();
      burstRefresh();
    },
    currentCurrency: resolvedCurrency,
    currentGeo: function () {
      return { ...geoState };
    }
  };
})();